export default __webpack_public_path__ + "static/media/Img5@2x.68f4ec2d.jpg";